import React, { useState, useEffect } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { GridOverlay, DataGrid } from "@mui/x-data-grid";
import NoDataFoundImage from "../images/commonicon/nodatafoundimage.jpg";
import useStyles from "../../styles";
import "./table.css";

function CustomTableView({
  columns,
  rows,
  Heading,
  onCheckboxClick,
  onPageChange,
}) {
  function CustomNoRowsOverlay() {
    return (
      <GridOverlay>
        <img src={NoDataFoundImage} alt="img" />
      </GridOverlay>
    );
  }

  //     const [page, setPage] = useState(0);

  //     const handlePageChange = (newPage) => {
  //   setPage(newPage);
  //   onPageChange(newPage) // Pass newSelection directly
  // };

  const classes = useStyles();

  const handleSelectionModelChange = (newSelection) => {
    onCheckboxClick(newSelection); // Pass newSelection directly
  };
  const [statusFilter, setStatusFilter] = useState("all");

  const [selectedColumns, setSelectedColumns] = useState(
    columns.map((col) => col.field) // default: all selected
  );

  const allColumnFields = columns.map((col) => col.field);
  const isAllSelected = selectedColumns.length === allColumnFields.length;

  const getRowStatus = (row, highlightEnabled) => {
    if (!highlightEnabled) return "zebra";

    const syncOk =
      String(row.sync_status).toLowerCase() === "yes" ||
      row.sync_status === true ||
      row.sync_status === 1;

    const resultOk =
      String(row.result_genrate).toLowerCase() === "yes" ||
      row.result_genrate === true ||
      row.result_genrate === 1;

    const logsSyncOk =
      String(row.logs_sync_status).toLowerCase() === "yes" ||
      row.logs_sync_status === true ||
      row.logs_sync_status === 1;

    const attemptMatch =
      Number(row.live_attempt_count) >= Number(row.attempt_count);

    const logsMatch = Number(row.live_logs_count) >= Number(row.logs_count);

    if (resultOk && logsSyncOk) {
      if (!attemptMatch) return "attempt-mismatch";
      if (!logsMatch) return "logs-mismatch";
      return "all-good";
    }

    if (!syncOk) return "critical";

    return "zebra";
  };

  const downloadCSV = () => {
    if (selectedColumns.length === 0) {
      alert("Please select at least one column");
      return;
    }

    const highlightEnabled =
      String(Heading?.[0]?.highlight).toLowerCase() === "yes" ||
      Heading?.[0]?.highlight === true ||
      Heading?.[0]?.highlight === 1;

    const filteredRows = rows.filter((row) => {
      if (statusFilter === "all") return true;
      return getRowStatus(row, highlightEnabled) === statusFilter;
    });

    const selectedCols = columns.filter((col) =>
      selectedColumns.includes(col.field)
    );

    const headers = selectedCols.map((col) => col.headerName).join(",");

    const csvRows = filteredRows.map((row) =>
      selectedCols.map((col) => `"${row[col.field] ?? ""}"`).join(",")
    );

    const csvContent = [headers, ...csvRows].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "table-data.csv";
    link.click();
  };

  return (
    <>
      {Heading?.map((data) => (
        <div
          className={`${classes.w100} ${classes[data.height]} ${
            classes[data.style]
          }`}
          key={data.style}
        >
          {Heading?.[0]?.highlight && (
            <div className={`${classes.dflex}`}>
              <FormControl size="small" style={{ minWidth: 220, margin: 12 }}>
                <InputLabel>Status Filter</InputLabel>
                <Select
                  value={statusFilter}
                  label="Status Filter"
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="all-good">🟢 All Good</MenuItem>
                  <MenuItem value="attempt-mismatch">
                    🟠 Attempt Mismatch
                  </MenuItem>
                  <MenuItem value="logs-mismatch">🔵 Logs Mismatch</MenuItem>
                  <MenuItem value="critical">🔴 Critical Failure</MenuItem>
                </Select>
              </FormControl>
              <FormControl size="small" style={{ width: 260, margin: 12 }}>
                <InputLabel>Select Columns</InputLabel>
                <Select
                  multiple
                  value={selectedColumns}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                      },
                    },
                  }}
                  label="Select Columns"
                  renderValue={(selected) =>
                    columns
                      .filter((col) => selected.includes(col.field))
                      .map((col) => col.headerName)
                      .join(", ")
                  }
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value.includes("all")) {
                      setSelectedColumns(isAllSelected ? [] : allColumnFields);
                    } else {
                      setSelectedColumns(value);
                    }
                  }}
                >
                  <MenuItem value="all">
                    <Checkbox
                      checked={isAllSelected}
                      indeterminate={
                        selectedColumns.length > 0 &&
                        selectedColumns.length < allColumnFields.length
                      }
                    />
                    <ListItemText primary="Select All" />
                  </MenuItem>

                  {columns.map((col) => (
                    <MenuItem key={col.field} value={col.field}>
                      <Checkbox checked={selectedColumns.includes(col.field)} />
                      <ListItemText primary={col.headerName} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Button
                variant="contained"
                color="primary"
                className={`${classes.bluebtn}`}
                style={{ margin: 12 }}
                onClick={downloadCSV}
              >
                Download CSV
              </Button>
            </div>
          )}

          {/* {console.log('pageSizepageSizepageSizepageSize', data.pageSize, rows, data.page)} */}
          <DataGrid
            // rows={rows}
            rows={rows.filter((row) => {
              if (statusFilter === "all") return true;

              const highlightEnabled =
                String(Heading?.[0]?.highlight).toLowerCase() === "yes" ||
                Heading?.[0]?.highlight === true ||
                Heading?.[0]?.highlight === 1;

              return getRowStatus(row, highlightEnabled) === statusFilter;
            })}
            columns={columns}
            components={{
              NoRowsOverlay: CustomNoRowsOverlay,
            }}
            // getRowClassName={(params) =>
            //   params.indexRelativeToCurrentPage % 2 === 0
            //     ? "Mui-even"
            //     : "Mui-odd"
            // }
            getRowClassName={(params) => {
              const highlightEnabled =
                String(data.highlight).toLowerCase() === "yes" ||
                data.highlight === true ||
                data.highlight === 1;

              const status = getRowStatus(params.row, highlightEnabled);

              switch (status) {
                case "all-good":
                  return "row-all-good";
                case "attempt-mismatch":
                  return "row-attempt-mismatch";
                case "logs-mismatch":
                  return "row-logs-mismatch";
                case "critical":
                  return "row-critical-failed";
                default:
                  return params.indexRelativeToCurrentPage % 2 === 0
                    ? "Mui-even"
                    : "Mui-odd";
              }
            }}
            checkboxSelection={data.checkboxselection}
            selectionModel={data.selectionModel}
            rowCount={data.rowCount || rows.length}
            hideFooter={data.footer}
            page={data.page || 0}
            pageSize={data.pageSize || 100}
            // onPageChange={data.handlePageChange}
            // onPageSizeChange={(newPageSize) => data?.setPageSize(newPageSize)}
            onPageChange={(newPage) => {
              if (typeof data?.handlePageChange === "function") {
                data.handlePageChange(newPage);
              }
            }}
            onPageSizeChange={(newPageSize) => {
              if (typeof data?.setPageSize === "function") {
                data.setPageSize(newPageSize);
              }
            }}
            pagination
            paginationMode={data.paginationMode || "client"}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            disableSelectionOnClick
            onSelectionModelChange={handleSelectionModelChange} // Handle checkbox selection change
          />
        </div>
      ))}
    </>
  );
}

export default CustomTableView;
